import { useTheme } from 'styled-components'

import { Typography } from '../../Typography'

import type { UserResultCardProfileProps } from './UserResultCard.Types'
import {
  StyledContainer,
  StyledProfileImage,
  StyledUserContainer,
} from './UserResultCardProfile.Styled'

export const UserResultCardProfile = ({
  imageProfile,
  name,
  result,
}: UserResultCardProfileProps) => {
  const theme = useTheme()

  return (
    <StyledContainer>
      <StyledProfileImage {...imageProfile} alt="Profile image" />
      <StyledUserContainer>
        <Typography $variant="Poppins/T2 - Medium">{name}</Typography>
        <Typography
          $color={theme.colors['N Content/Highlighted']}
          $variant="Poppins/T3"
        >
          {result}
        </Typography>
      </StyledUserContainer>
    </StyledContainer>
  )
}
